<!-- src/components/Joakim/RecentDocuments.vue -->
<template>
    <div class="blur-wrapper" :style="{ filter: joakim.skjolSpinner ? 'blur(3px)' : 'blur(0)' }">
  <div class="recent-documents">
      <div class="recent-documents-header">
            <h4>{{ t('skjalaundirsida_header')}}</h4>
          <router-link to="/skjol/sjodfelaga" class="see-all">{{ t('idgjaldarsida_SeeAll') }}</router-link>
      </div>


    <ul class="document-list">
      <li v-for="skjal in recentSkjol" :key="skjal.skjalID" class="document-item">
        <div class="document-icon">
          <component :is="getIconComponent(skjal.tegund)" />
        </div>
        <div class="document-meta">
            <a
            class="download-link"
            @click.prevent="joakim.downloadSkjal(skjal.skjalID)"
            href="#"
            >
            {{ skjal.lysing }}
            </a>
          <div class="document-date">
           {{ formatDateTimeLocalized(skjal.dags, locale) }}
          </div>
        </div>
      </li>
    </ul>
  </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useJoakimStore } from '@/stores/useJoakimStore'
import { useAuthStore } from '@/stores/useAuthStore'
import { useI18n } from 'vue-i18n'
import IconDefault from '../SVG/iconDefault.vue'
import ChartIcon from '../SVG/ChartIcon.vue'
import { formatDateTimeLocalized } from '@/utils/dateUtils'



const auth = useAuthStore();
const { t, locale  } = useI18n()

const joakim = useJoakimStore()

const recentSkjol = computed(() => joakim.skjol.slice(0, 5))


onMounted(async () => {
    if (joakim.skjol.length === 0) {
        joakim.getSkjol();
    }
});


function getIconComponent(tegund: string) {
  return tegund === 'Sjóðfélagayfirlit' ? ChartIcon : IconDefault
}


</script>

<style scoped>
.recent-documents {
  display: flex;
  flex-direction: column;
  padding: 16px;
}
.recent-documents-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
}

a.download-link {
  color: inherit;
  text-decoration: none;
  font-weight: 500;
}

a.download-link:hover {
  text-decoration: underline;
}
.document-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.document-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.document-icon {
  margin-right: 16px;
}
.document-date {
  font-size: 0.875rem;
  color: #666;
}
.see-all {
  margin-top: 12px;
  display: inline-block;
  font-weight: bold;
  color: #000000de;
  text-decoration: none;
  font-size: 14px;
}
.blur-wrapper {
  transition: filter 0.3s ease;
}
</style>
